/* eslint-disable ember/no-classic-components, ember/require-tagless-components, warp-drive/no-legacy-request-patterns */
// Extends From
import Component from '@ember/component';
import { tracked } from '@glimmer/tracking';
// Ember Imports
import { service } from '@ember/service';
// Internal Imports
import Unit from 'linced-app/enums/medical/unit';
import { action } from '@ember/object';
// External Imports

const reductionUnits = [Unit.EACH];
export default class MedicationAdministerConfirm extends Component {
  @service
  session;

  @service
  store;

  @service
  toaster;

  @tracked
  dialogOpen = false;

  disabled = false;

  log = null;

  onSave() {}

  @tracked
  saveInProgress = false;

  @tracked
  quantity = 0;

  @action
  setQuantity(value) {
    this.quantity = value;
  }

  @tracked
  reason = 0;

  @action
  openDialog() {
    let reduction = 0;
    if (reductionUnits.includes(this.log.medication.get('unit'))) {
      reduction = 1;
    }
    this.quantity = this.log.batch.get('quantity') - reduction;
    this.dialogOpen = true;
  }

  @action
  closeDialog() {
    this.reason = 0;
    this.dialogOpen = false;
  }

  // save keeps the dialog open on a failure so it can be retried. The batch
  // quantity is absolute, so saving it again on a retry is safe.
  @action
  async save() {
    this.saveInProgress = true;
    let batch = this.store.peekRecord(
      'medical/batch',
      this.log.batch.get('id'),
    );
    batch.set('quantity', this.quantity);
    this.log.set('reason', this.reason);

    try {
      await batch.save();
    } catch {
      batch.rollbackAttributes();
      this.toaster.error('Batch save failed!');
      this.saveInProgress = false;
      return;
    }

    if (this.schedule) {
      this.log.set('schedule', this.schedule);
    }
    try {
      await this.log.save();
    } catch {
      // Unlink the unsaved log, or the schedule shows it as administered.
      this.log.set('schedule', null);
      this.toaster.error('Administration save failed!');
      this.saveInProgress = false;
      return;
    }

    this.toaster.success('Administration saved successfully!');
    this.saveInProgress = false;
    this.dialogOpen = false;
    this.onSave();
  }
}
